import { useWatch } from "react-hook-form";

import HintCard from "./HintCard";
import { WIZARD_HINT_CONTENT } from "./hintContent";
import { useFieldFocus } from "./useFieldFocus";
import WizardStep from "./WizardStep";
import TemplateFields from "../TemplateBuilder/components/TemplateFields";

export default function TemplateStructureStep({
  control,
  onNext,
  onBack,
}) {
  const { focusedField, containerRef } = useFieldFocus();
  const hint = focusedField
    ? WIZARD_HINT_CONTENT[focusedField]
    : null;

  const templateFields = useWatch({
    control,
    name: "templateFields",
  });
  const hasContent = templateFields?.some((field) =>
    field.fieldValue?.trim(),
  );

  return (
    <WizardStep
      title="Edit Template Structure"
      description="This helps Scribenote's AI understand what overall structure you'd like for your note. You can include specific preferences in each section here, or set whole-note preferences in the next step."
      onNext={onNext}
      onBack={onBack}
      nextDisabled={!hasContent}
      dataTestId="wizard-step-template-structure"
    >
      <div className="flex gap-lg" ref={containerRef}>
        <div className="flex-1 min-w-0 flex flex-col gap-md">
          <TemplateFields control={control} />
        </div>
        <div className="hidden lg:block w-72 shrink-0">
          <div className="sticky top-20">
            <HintCard
              title={hint?.title}
              body={hint?.body}
              visible={!!hint}
              dataTestId="wizard-structure-hint"
            />
          </div>
        </div>
      </div>
    </WizardStep>
  );
}
